import { ReactNode, useState } from "react";
import Header from "../navigation/Header";
import Footer from "../navigation/Footer";
import VoiceAssistantWidget from "../widgets/VoiceAssistantWidget";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isVoiceAssistantVisible, setIsVoiceAssistantVisible] = useState(false);

  const toggleVoiceAssistant = () => {
    setIsVoiceAssistantVisible(!isVoiceAssistantVisible);
    console.log('Voice assistant visibility toggled:', !isVoiceAssistantVisible);
  };

  return (
    <div className="flex flex-col min-h-screen layout-stable" data-id="eexpciyhi" data-path="src/components/layout/Layout.tsx">
      <Header data-id="5idlor4s8" data-path="src/components/layout/Layout.tsx" />
      <main className="flex-grow" data-id="zoujg2mpc" data-path="src/components/layout/Layout.tsx">
        {children}
      </main>
      <VoiceAssistantWidget
        isVisible={isVoiceAssistantVisible} data-id="ez2gic6gx" data-path="src/components/layout/Layout.tsx" />
      <Footer onToggleVoiceAssistant={toggleVoiceAssistant} data-id="r22fw31kk" data-path="src/components/layout/Layout.tsx" />
    </div>);

}